import { Fragment, useEffect, useState } from 'react';

import { SearchResultsAll } from 'components/search/search-results-all';
import { SearchResultsRecent } from 'components/search/search-results-recent';
import { SearchResultsTrending } from 'components/search/search-results-trending';
import { useSearch, useStorage } from 'contexts';

const SearchResultsPreview = ({ query, hits = [], loading, tableName, tableNames }) => {
	const [recent, setRecent] = useState([]);
	const search = useSearch();
	const storage = useStorage();

	// Hooks
	useEffect(() => {
		const queries = storage.getValue('search') || [];
		const results = queries
			.filter(v => (tableName ? tableName === v.modelName : true))
			.filter(v => (tableNames.length > 0 ? tableNames.includes(v.modelName) : true))
			.sort((a, b) => (a.date < b.date ? 1 : -1));
		setRecent(results);
	}, [storage.storage.search, tableName, tableNames]);

	// Render
	return (
		<Fragment>
			{query.length >= 3 ? (
				<SearchResultsAll hits={hits} query={query} loading={loading} onClick={search.onClick} className='gap-0' />
			) : (
				<Fragment>
					{recent.length > 0 ? (
						<SearchResultsRecent
							api={{ page: 0, pageSize: 6 }}
							tableName={tableName}
							tableNames={tableNames}
							onClick={search.onClick}
							className='gap-0'
						/>
					) : (
						<SearchResultsTrending
							query={query}
							api={{ page: 0, pageSize: 6 }}
							tableName={tableName}
							tableNames={tableNames}
							onClick={search.onClick}
							className='gap-0'
						/>
					)}
				</Fragment>
			)}
		</Fragment>
	);
};
export { SearchResultsPreview };
